module.exports = __webpack_public_path__ + "images/directory/featured-hero/dropbox.b9a2a4ded4dd7bc3345b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/dropbox.png
// module id = KPAI
// module chunks = 2